import React from "react";
import me from '../assets/images/me.png';
import './Landing.css'
import Navbar from "../components/Navbar.js";
import { animated, useSpring } from '@react-spring/web';
import { BsArrowDown } from "react-icons/bs";

export default function Landing() {
    const [props] = useSpring(() => ({
        from: { 
            opacity: 0,
        },
        to: { 
            opacity: 1,
        },
        config: { 
            duration: 1000
        }
    }), []);

    return(
        <div className="landing">
            <Navbar/>
            <div className="columns">
                <animated.div style={props} className="landing-text">
                    <p className="landing-description-subtext">
                        Software Engineer
                    </p>
                    <div className="name-div">
                        <p 
                        className="landing-description-name"
                        >
                            Fionn
                        </p>   
                        <p 
                        className="landing-description-name"
                        >
                            Camacho
                        </p>
                        <p 
                        className="landing-description-name"
                        >
                            Lenihan
                        </p>
                    </div>
                    <p className="landing-description-subtext">
                        FionnCL
                    </p>
                </animated.div>
                <div className="landing-image">
                    <img 
                    src={me}
                    className="me-image"
                    alt="Just regular ol' me."
                    />
                </div>
            </div>
            <div className="divider">
                <BsArrowDown className="arrow" size={30}/>
                <h1> Projects </h1>
                <BsArrowDown className="arrow" size={30}/>
            </div>
        </div>
    );
}
